export enum ErrorType {
  POINT = 'point',
  JOURNEY = 'journey'
}
